import moment from 'moment';
import { PaymentMethod, usePaymentMethods } from 'queries';
import { useMemo } from 'react';

export const useUsablePaymentMethods = (
  organizationId?: string,
  sessionId?: string,
  filter: 'all' | 'usable' | 'notUsable' = 'usable',
  justAdded?: string[],
) => {
  const { data: allPaymentMethods, isLoading } =
    usePaymentMethods(organizationId);

  const paymentMethods = useMemo(() => {
    const isUsable = (pm: PaymentMethod) => {
      const exp = `${pm.expMonth}/${pm.expYear}`;
      const expired = moment(exp, 'MM/YYYY').add(1, 'month').isBefore(moment());
      if (expired) {
        return false;
      }
      if (justAdded?.includes(pm.id)) {
        return true;
      }

      return pm.allowReuse || (pm.sessionId && pm.sessionId === sessionId);
    };

    if (!allPaymentMethods) return [];
    if (filter === 'all') return allPaymentMethods;
    if (filter === 'usable')
      return allPaymentMethods.filter((pm) => isUsable(pm));
    if (filter === 'notUsable')
      return allPaymentMethods.filter((pm) => !isUsable(pm));
    return [];
  }, [allPaymentMethods, sessionId, filter, justAdded]);

  return {
    paymentMethods,
    isLoading,
  };
};
